<template>
  <div id="carousel">
    <div class="w-100 d-none d-mb-block">
      <el-carousel :interval="5000" arrow="always" height="100vh">
        <el-carousel-item v-for="item in bannerURL" :key="item.id">
          <a v-if="item.links" :href="item.links" target="_blank">
            <img :src="imgURL + item.pic" alt="" width="100%" height="100%" />
          </a>
          <img v-else :src="imgURL + item.pic" alt="" width="100%" height="100%" />
          <div class="workInfo">
            <strong class="font-s-18">{{ item.workInfo }}</strong>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="w-100 d-block d-mb-none pt-60">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="item in bannerURL" :key="item.id">
          <a v-if="item.links" :href="item.links" target="_blank">
            <img :src="imgURL + item.pic" alt="" width="100%" height="250px" />
          </a>
          <img v-else :src="imgURL + item.pic" alt="" width="100%" height="100%" />
          <div class="swiper__workInfo">
            <strong class="font-s-14">{{ item.workInfo }}</strong>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgURL: process.env.VUE_APP_BASE_IMG_URL,
      swiperOption: {
        spaceBetween: 5,
        loop: true,
      },
      bannerURL: [],
    };
  },
  computed: {
    getScreenH() {
      return screen.height;
    },
  },
  methods: {
    getGraduateBanner() {
      this.$api.getGraduateBanner().then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          try {
            this.bannerURL = data;
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  mounted() {
    this.getGraduateBanner();
  },
};
</script>

<style lang="scss">
#carousel {
  position: relative;
  width: 100%;
  .workInfo {
    position: absolute;
    right: 95px;
    bottom: 40px;
    color: #4f4f4f;
  }

  .swiper {
    position: relative;
    &__workInfo {
      position: absolute;
      right: 8px;
      bottom: 8px;
      color: #4f4f4f;
    }
  }

  //因為會被左邊 bar 條擋住，所以要調整成最上層
  .el-carousel__arrow,
  .el-carousel__arrow--left {
    z-index: 999;
  }
}
</style>